<template lang="">
    <FileView 
        :title="fileTitle" 
        view="list"
        :allItems="allItems"
        :viewAllOption="viewAllOption"
        :listViewColumns="listColumns"
        sortParam="sort_by"
        :activeSortedColumn="activeSortedColumn"
        :isLoading="isLoading"
        :noDataTitle="noDataFileTitle"
        :dataType="fileType"
        :classes="classes"
        :increment="increment"
        :isDataLoading="isDataLoading"
        :onMounted="onMounted"
        :perpage="perpage"
        :routeType="routeType" />
</template>
<script>
import FileView from "../../../components/FileView/FileView.vue";
import { eventBus } from '../../../../../../Pages/assets/eventBus.js';
export default {
    components: { FileView },
    data() {
        return {
            viewAllOption: false,       
            listViewColumns: [
                {id: 1, name: 'Name', sortASC: 'file_name_asc', sortDESC: 'file_name_desc'},
                {id: 2, name: 'Date Created', sortASC: 'file_created_at_asc', sortDESC: 'file_created_at_desc'},
                {id: 3, name: 'Size', sortASC: 'file_size_asc', sortDESC: 'file_size_desc'}
            ],
            activeSortedColumn: 'file_created_at_desc',
            isLoading: true
        };
    },
    props: {
        allItems: {
            type: Array,
            default: [],
            required: true,
        },
        fileTitle: {
            type: String,
            default: null,
            required: true,
        },
        fileType: {
            type: String,
            default: null,
            required: true,
        },
        noDataFileTitle: {
            type: String,
            default: null,
            required: true,
        },
        classes: {
            type: String,
            required: true
        },
        increment: {
            type: Number,
            required: true
        },
        isDataLoading: {
            type: Boolean,
            required: true
        },
        onMounted: {
            type: Function,
            required: true
        },
        perpage: {
            type: Number,
            default: 12,
            required: true
        },
        routeType: {
            type: String,
            default: null
        }
    },

    created() {
        eventBus.$on('sortingColumn', (datas) => {
            if(datas.item === 'sort_by') {
                this.activeSortedColumn = datas.value;
                eventBus.documentManagerLoading('File', true);
            }
        });
        eventBus.$on('isDocumentManagerLoading', (datas) => {
            if(datas.type === 'File') {
                this.isLoading = datas.value;
            }
        });
    },
    computed: {
        listColumns() {
            if(this.fileType === 'Shared') {
                const extraColmns = {id: 4, name: 'Shared By', sortASC: 'file_shared_by_asc', sortDESC: 'file_shared_by_desc'}                
                this.listViewColumns = [...this.listViewColumns, extraColmns]                
            }
            const actionColmn = {id: this.listViewColumns.length, name: 'Actions', sortASC: null, sortDESC: null}
            this.listViewColumns = [...this.listViewColumns, actionColmn]
            return this.listViewColumns
        }
    },
};
</script>
<style lang=""></style>
